import React from 'react'
import { useLanguageContext } from '../../contexts/LanguageContext'
import './Token.css'
import SEO from '../seo/SEO'

const Token: React.FC = () => {
  const { content } = useLanguageContext()

  return (
    <>
      <SEO 
        title={content.token.seo.title} 
        description={content.token.seo.description} 
      />
      <section id="token" className="token-section">
        <div className="container">
          <div className="token-header text-center">
            <p className="section-subtitle">{content.token.subtitle}</p>
            <h2 className="section-title">{content.token.title}</h2>
            <p className="section-description">{content.token.description}</p>
          </div>

          <div className="features-grid">
            {content.token.features.map((feature: any, index: number) => (
              <div key={index} className="token-feature-card card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="token-coming-soon text-center">
            <p className="coming-soon-text">{content.token.comingSoon}</p>
          </div>
        </div>
      </section>
    </>
  )
}

export default Token 